export const JawaMark = ({ className = "h-9 w-9", dark = false }) => (
  <img
    src={dark ? "/logo-on-light.png" : "/logo-on-dark.png"}
    alt="JÀWÀ AFRICA"
    className={`${className} object-contain`}
  />
);

export const JawaWordmark = ({ dark = false }) => (
  <span className="flex items-center" data-testid="jawa-logo">
    <JawaMark dark={dark} className="h-14 w-14" />
  </span>
);
